__turbopack_context__.v({
  "cell": "OrderSuccessBanner-module-scss-module__bJeMEG__cell",
});
